import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-mui';
import * as Yup from 'yup';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const ContactForm = (props) => {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const [success, setSuccess] = React.useState(null);
	const [error, setError] = React.useState();

	const schema = Yup.object().shape({
		firstName: Yup.string().required('Please provide your first name.'),
		lastName: Yup.string().required('Pease provide your last name.'),
		email: Yup.string().email('Please enter a valid email address.').required('Please provide your email address.'),
		phone: Yup.string().required('Please provide your phone number.'),
		company: Yup.string().required('Please provide your company name.'),
	});

	const initialValues = {
		firstName: '',
		lastName: '',
		email: '',
		phone: '',
		company: '',
		comments: '',
		env: 'CONTACT_FORM',
	}

	const handleSubmit = React.useCallback(async (props, {setSubmitting}) => {
		if (!executeRecaptcha) {
			return null;
		}
		const token = await executeRecaptcha('contact');
		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(Object.assign({}, props, {fields: Object.keys(props), recaptcha: token })),
		};
		fetch(`${process.env.GATSBY_ZMS_API_URL}contact/mail/`, options)
			.then(async function (response) {
				if (!response.ok) {
					const body = await response.json();
					throw new Error(body.errorMessage);
				}
				return response.json();
			})
			.then((json) => {
				if (typeof window !== 'undefined') {
					window.dataLayer = window.dataLayer||[];
					window.dataLayer.push({
						event: 'contact_submit',
						formID: 'contact',
						success: true,
						...props,
					});
				}
				setSuccess(true);
			})
			.catch(function (err) {
				if (typeof window !== 'undefined') {
					window.dataLayer = window.dataLayer||[];
					window.dataLayer.push({
						event: 'contact_error',
						formID: 'contact',
						error: err,
						...props,
					});
				}
				setError(err.errorMessage);
				setSubmitting(false);
			})
		;
	}, [executeRecaptcha]);

	// const submitForm = (props) => {
	// 	handleSubmit(props);
	// 	return true;
	// };

	React.useEffect(() => {
		if (props.onSuccess && success === true)props.onSuccess();
	}, [success, props]);

	React.useEffect(() => {
		if (error)console.log(error);
	}, [error]);

	return (
		<Box>
			{ !success &&
				<Formik validationSchema={schema} onSubmit={handleSubmit} initialValues={initialValues}>
					{({ errors, touched, submitForm, isSubmitting }) => (
						<Form>
							<Grid container spacing={{ xs: 2, md: 4 }}>
								{/* Row 1: First Name and Last Name side-by-side */}
								<Grid size={{ xs: 12, md: 6 }}>
									<Field
										component={TextField}
										fullWidth
										required
										label="First Name"
										name="firstName"
										variant="outlined"
									/>
								</Grid>
								<Grid size={{ xs: 12, md: 6 }}>
									<Field
										component={TextField}
										fullWidth
										required
										label="Last Name"
										name="lastName"
										variant="outlined"
									/>
								</Grid>
								{/* Row 1: First Name & Last Name side-by-side */}
								{/* Row 2: Email & Phone side-by-side */}
								<Grid size={{ xs: 12, md: 6 }}>
									<Field
										component={TextField}
										required
										fullWidth
										label="Email"
										name="email"
										variant="outlined"
									/>
								</Grid>
								<Grid size={{ xs: 12, md: 6 }}>
									<Field
										component={TextField}
										required
										fullWidth
										label="Phone Number"
										name="phone"
										variant="outlined"
									/>
								</Grid>
								{/* Row 2: Email & Phone side-by-side */}
								{/* Row 3: Company */}
								<Grid size={{ xs: 12 }}>
									<Field
										component={TextField}
										required
										fullWidth
										label="Company"
										name="company"
										variant="outlined"
									/>
								</Grid>
								{/* Row 3: Company */}
								{/* Row 4: Questions/Comments */}
								<Grid size={{ xs: 12 }}>
									<Field
										component={TextField}
										fullWidth
										label="Questions/Comments"
										name="comments"
										variant="outlined"
									/>
								</Grid>
								{/* Row 4: Questions/Comments */}
								<Grid size={{xs: 12}} className="contact_form__submit__wrapper">
									<Button variant={'contained'} disabled={isSubmitting} onClick={submitForm}>Submit</Button>
								</Grid>
							</Grid>
						</Form>
					)}
				</Formik>
			}
			{ success &&
				<Box style={{textAlign: 'center'}}>
					<Typography variant="h2" component="h2">Thank you!</Typography>
					<p>Zehnder is always on the lookout for great collaborators. We’ll be in touch.</p>
				</Box>
			}
		</Box>
	);
};

export default ContactForm;
